// @ts-ignore Untyped module
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { Provider } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncContentAssistanceProxiedToolbar = makeAsyncComponent(() => import( /* webpackChunkName: "ContentAssistanceProxiedToolbar" */'ContentEditorUI/containers/ContentAssistanceProxiedToolbarContainer'), {
  waitUntilDocumentReadyToLoadDeps: true
});
const AsyncContentAssistanceProxiedAutocompleteMenu = makeAsyncComponent(() => import( /* webpackChunkName: "ContentAssistanceProxiedAutocompleteMenu" */'ContentEditorUI/containers/ContentAssistanceProxiedAutocompleteContainer'));

// This is my hack to allow using the state within tinyMCE component.
// Alternativley, could use `window.hs.app.store` - but want to use the same state that
// InpageEditor is using (this is used in EditController)
export const getPickerComponentsProvider = store => ({
  ContentAssistanceToolbar(props) {
    return /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(AsyncContentAssistanceProxiedToolbar, Object.assign({}, props))
    });
  },
  ContentAssistantAutocompleteMenu(props) {
    return /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(AsyncContentAssistanceProxiedAutocompleteMenu, Object.assign({}, props))
    });
  }
});